import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DomainControllerService } from "../../../../services/service-controller/domain-controller.service";
import { ServiceControllerService } from "../../../../services/service-controller/service-controller.service";
import { ToastrService } from "ngx-toastr";
import { Service } from "../../../../models/service";
import { ServiceAttribute } from "../../../../models/service-attribute";
import { AttributesControllerService } from "../../../../services/attributes-controller/attributes-controller.service";
import { ServiceCategoryControllerService } from "../../../../services/service-categories-controller/service-category-controller.service";
import { ServiceCategory } from "../../../../models/service-category";
import { environment } from "../../../../../environments/environment";
import {TranslatedBaseError} from "../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "service-options",
  templateUrl: "./service-options.component.html",
  providers: [ServiceControllerService, DomainControllerService, ToastrService],
})
export class ServiceOptionsComponent extends TranslatedBaseError implements OnInit {

  public serviceId: string;
  public service: Service;
  public isLoading: boolean = false;

  public allCategories: ServiceCategory[];
  public serviceCategories: ServiceCategory[];

  public readonly publishing: string = "Publishing";
  public readonly categories: string = "Categories";
  public services: any[];
  public initialValue: string = "";
  public logoUrl: string;
  private restheartUrl: string = environment.RESTHEART_URL;
  public domains: string[] = [];

  constructor(
    private serviceControllerService: ServiceControllerService,
    private domainControllerService: DomainControllerService,
    public toastr: ToastrService,
    public translateService: TranslateService,
    private attributesControllerService: AttributesControllerService,
    private serviceCategoryControllerService: ServiceCategoryControllerService,
    private route: ActivatedRoute,
  ) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.route.parent.params.subscribe((params) => {
      this.serviceId = (params.serviceId === "new") ? null : params.serviceId;
      if (this.serviceId !== null) {
        this.loadService();
      } else {
        this.service = new Service();
      }
    });
  }

  public loadService() {
    this.serviceControllerService.getService(this.serviceId).subscribe(
      (data: Service) => {
        console.log("---data", data);
        this.service = data;
        if (!this.service.serviceJsonProperties.domain || this.service.serviceJsonProperties.domain === "all") {
          this.service.serviceJsonProperties.domain = "null";
        }
        if (!this.service.registrations) {
          this.service.registrations = [];
        }
        if (!this.service.serviceCategories) {
          this.service.serviceCategories = [];
        }
        if (!this.service.serviceAttributes) {
          this.service.serviceAttributes = [];
        }
      },
    );
  }

  public saveService(remoteService) {
    this.service = remoteService;
    if (this.service && this.service.serviceJsonProperties && this.service.serviceJsonProperties.domain === "null") {
      this.service.serviceJsonProperties.domain = null;
    }
    if (!this.isLoading) {
      this.isLoading = true;
      this.serviceControllerService.saveService(this.service, null).subscribe(
        (data) => {
          this.responseSuccessful("Publishing options saved");
        },
        (error) => this.showErrorMessage(error),
        () => this.isLoading = false,
      );
    }
  }

}
